module.exports = __webpack_public_path__ + "static/slider-1-2-1dd718110d6e0d4778a5def0b6fcd461.webp";